<template>
  <tr class="statistic-header">
    <td class="statistic__header-title">
      Статистика

      <div class="statistic-controls">
        <ul class="statistic-list">
          <li class="statistic-list__controls">
            <button
              v-for="(item, key) in controlsData"
              :key="key"
              @click="onClick(key)"
              :class="`statistic-list__button ${getActiveButton(key)}`"
            >
              {{item.title}}
            </button>
          </li>
        </ul>
      </div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'StatisticHeader',
  data() {
    return {
      activeClassButton: 'statistic-list__button--active',
    };
  },
  props: {
    controlsData: {
      type: Object,
      required: true,
    },
    active: {
      type: String,
      required: true,
    },
  },
  methods: {
    onClick(key) {
      this.$emit('onClick', key);
    },
    getActiveButton(key) {
      return this.active === key ? this.activeClassButton : '';
    },
  },
};
</script>

<style scoped>
  .statistic-header {
    display: block;
    padding-bottom: 5px;
    margin-bottom: 7px;
    text-align: left;
    border-bottom: 1px solid #c4c4c4;
  }

  .statistic-controls {
    text-align: right;
  }

  .statistic-list {
    display: flex;
    justify-content: flex-end;
    padding: 0;
    margin: 0;
    list-style: none;
  }

  .statistic-list__controls {
    display: flex;
  }

  .statistic__header-title {
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-family: "Oswald", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 18px;
    line-height: normal;
    text-transform: uppercase;
    letter-spacing: 0.1em;
  }

  .statistic-list__button {
    margin-right: 10px;
    padding: 0 10px 3px 10px;
    font-family: "Oswald", "Arial", sans-serif;
    font-style: normal;
    font-weight: 300;
    font-size: 12px;
    line-height: normal;
    color: #000000;
    border: none;
    background-color: transparent;
    cursor: pointer;
  }

  .statistic-list__button:last-child {
    margin-right: 0;
  }

  .statistic-list__button:hover,
  .statistic-list__button:focus,
  .statistic-list__button:active,
  .statistic-list__button--active {
    outline: none;
    background-color: #0084ff;
    color: #ffffff;
  }

  @media (max-width: 1040px) {
    .statistic-header {
      padding-bottom: 15px;
    }
  }
</style>
